import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  admin,
  kancelar,
  pedagog,
  specialistFF,
} from '../../../components/common/common-functions/common-functions';
import { getCommonUrl } from '../../../components/common/common-functions/commonApiUrl/get-common-url';
import { handleDownloadResponse } from '../../../components/common/common-functions/handle-response';
import { ROLES } from '../../../constants/enums/roles';
import getConfig from '../../../helpers/config';
import { UpdateProps } from '../../../interfaces/common-interfaces';
import {
  CreateNewEvidenceProps,
  EvidenceBody,
  EvidenceProps,
  ExportEvidenca,
  UpdateEvidenca,
} from '../../../interfaces/evidenca-interface';
import { ListePrezencaParams } from '../../../interfaces/liste-prezenca.interface';
import { PaginationReturn } from '../../../interfaces/pagination';
import { getPrepareHeaders } from '../get-prepare-headers';

const { test } = getConfig();

const getBaseUrl = (role: ROLES) => {
  if ([admin, specialistFF, kancelar].includes(role)) {
    return 'evidenca';
  }
  if (role === pedagog) {
    return 'evidenca/per-pedagog';
  }
  return '';
};

export const evidencaApi = createApi({
  reducerPath: 'evidencaApi',
  tagTypes: ['OrariEvidenca', 'getAllEvidenca'],
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl + `/`,
    prepareHeaders: getPrepareHeaders,
  }),
  endpoints: builder => ({
    getEvidenca: builder.query<
      PaginationReturn<EvidenceProps>,
      ListePrezencaParams
    >({
      query: ({ role, ...args }) =>
        getCommonUrl(args, getBaseUrl(role as ROLES)),
      providesTags: ['getAllEvidenca', 'OrariEvidenca'],
    }),
    getOrariEvidencaById: builder.query<EvidenceBody[], number>({
      query: id => ({
        url: `/evidenca/${id}/orari-mesimor`,
      }),
      providesTags: ['OrariEvidenca'],
    }),
    createEvidence: builder.mutation<number, CreateNewEvidenceProps>({
      query: body => ({
        url: '/evidenca',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['OrariEvidenca'],
    }),
    updateEvidence: builder.mutation<number, UpdateProps<UpdateEvidenca>>({
      query: ({ data, id }) => ({
        url: `/evidenca/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['OrariEvidenca', 'getAllEvidenca'],
    }),
    deleteEvidenca: builder.mutation<string, number>({
      query: id => ({
        url: `/evidenca/${id}`,
        method: 'DELETE',
        responseHandler: response => response.text(),
      }),
      invalidatesTags: ['OrariEvidenca', 'getAllEvidenca'],
    }),
    exportEvidenca: builder.query<Blob, ExportEvidenca>({
      query: args => ({
        url: getCommonUrl(args, 'evidenca/eksport'),
        responseHandler: handleDownloadResponse,
      }),
    }),
  }),
});

export const {
  useGetOrariEvidencaByIdQuery,
  useCreateEvidenceMutation,
  useUpdateEvidenceMutation,
  useGetEvidencaQuery,
  useDeleteEvidencaMutation,
  useLazyExportEvidencaQuery,
} = evidencaApi;
